export default {
  ADD_LOADED_SWAGGER: 'ADD_LOADED_SWAGGER_API_DOCS',
  SET_SIDENAV_SECTIONS: 'SET_SIDENAV_SECTIONS_API_DOCS',
  SET_ENTITY_LIST: 'SET_ENTITY_LIST',
  SET_ORIGINAL_SCHEMAS: 'SET_ORIGINAL_SCHEMAS',
};
